export default function typeWritter() {
    /*
     * @description     Animate typing text in an element
     * @param   {HTML Element} elementTyping - The element which the text be typed in it
     * @param   {string} text - The text that must be typed
     * @param   {number} speed(ms) - The speed of typing each character
     * @param   {number} delay(ms) - The delay before starting to type
     * @return  {Promise}
    */
    const typeText = (elementTyping, text, speed, delay) =>
        new Promise(resolve => {
            setTimeout(() => {
                let charIndex = 0;
                const typing = setInterval(() => {
                    elementTyping.textContent = text.substr(0, ++charIndex);
                    if (charIndex === text.length) {
                        clearInterval(typing);
                        resolve();
                    }
                }, speed);
            }, delay);
        });

    /*
     * @description     Animate removing text from an element
     * @param   {HTML Element} elementTyping - The element which the text be removed from it
     * @param   {number} speed(ms) - The speed of removing each character
     * @param   {number} delay(ms) - The delay before starting to remove
     * @return  {Promise}
    */
    const removeText = (elementTyping, speed, delay) =>
        new Promise(resolve => {
            setTimeout(() => {
                let text = elementTyping.textContent;
                const removing = setInterval(() => {
                    text = text.substr(0, text.length - 1);
                    elementTyping.textContent = text;
                    if (!text.length) {
                        clearInterval(removing);
                        resolve();
                    }
                }, speed);
            }, delay);
        });

    /*
     * @description     Show the cursor at the end of the text
     * @param   {HTML Element} elementTyping - The element to add an index to it
     * @param   {number} index - The index of each .animated-typing element
     * @param   {number} speed(ms) - The speed of blinking cursor
    */
    const showCursor = (elementTyping, index, speed) => {
        elementTyping.dataset.animateIndex = index;
        const style = document.createElement('style');
        style.innerHTML = `
            .animate-typing[data-animate-index="${index}"]::after {
                content: '|';
                animation: animateCursor ${speed}ms infinite alternate cubic-bezier(.68,-0.55,.27,1.55);
            }
        `;
        document.head.appendChild(style);
    }

    document.querySelectorAll('.animate-typing').forEach((elementTyping, index) => {
        const typeSpeed = +elementTyping.dataset.typeSpeed || 200;
        const typeDelay = +elementTyping.dataset.typeDelay || 200;
        const removeSpeed = +elementTyping.dataset.removeSpeed || 50;
        const removeDelay = +elementTyping.dataset.removeDelay || 500;
        const cursorSpeed = +elementTyping.dataset.cursorSpeed || 300;
        const loop = elementTyping.dataset.animateLoop || false;
        const textList = elementTyping.textContent.split('|');
        elementTyping.textContent = '';

        showCursor(elementTyping, index, cursorSpeed);

        (async () => {
            let cycle = 0;
            do {
                for (let subText of textList) {
                    if (cycle++) await removeText(elementTyping, removeSpeed, removeDelay);
                    if (subText.trim()) await typeText(elementTyping, subText.trim(), typeSpeed, typeDelay);
                }
            } while (loop);
        })();
    });

    const style = document.createElement('style');
    style.innerHTML = `
        @keyframes animateCursor {
            0% { opacity: 0; }
            100% { opacity: 1; }
        }
    `;
    document.head.appendChild(style);
}
